enum PATH {
  DASHBOARD = '/',
  MAIN_WINDOW = '/main_window',
  BOOKMARKS = '/bookmarks',
  INFO = '/info',
}

export default PATH;
